import React from 'react';
import { Shield } from 'lucide-react';
import { useMarket } from '../context/MarketContext';
import type { Position } from '../types';

export default function RiskPage() {
  const { positions, risk } = useMarket();
  // Use risk metrics from backend (calculated on VPS)
  const notional = risk.grossNotional;
  const long = risk.longExposure;
  const short = risk.shortExposure;

  const card = { background:'#1e293b', padding:16, borderRadius:8, border:'1px solid #334155' };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
      <div style={card}>
        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:12 }}>
          <Shield size={16} color="#94a3b8"/><h3 style={{ margin:0, fontSize:16, fontWeight:600 }}>Risk Monitor</h3>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:16 }}>
          <Tile k="Gross Notional" v={notional.toLocaleString()}/>
          <Tile k="Long Exposure" v={long.toLocaleString()} color="#10b981"/>
          <Tile k="Short Exposure" v={short.toLocaleString()} color="#ef4444"/>
        </div>
      </div>

      <div style={card}>
        <Header/>
        {positions.map((p,i)=><Row key={i} p={p}/>)}
      </div>
    </div>
  );
}

const Tile = ({k, v, color}:{k:string; v:string; color?:string}) => (
  <div style={{ background:'#0f172a', padding:16, borderRadius:8, border:'1px solid #334155' }}>
    <div style={{ color:'#94a3b8', fontSize:12 }}>{k}</div>
    <div style={{ fontSize:22, fontWeight:700, color }}>{v}</div>
  </div>
);

function Header() {
  return (
    <div style={{
      display:'grid', gridTemplateColumns:'100px 1fr 1fr 1fr', gap:8,
      padding:'8px 0', color:'#94a3b8', fontSize:12, borderBottom:'1px solid #334155'
    }}>
      <div>Symbol</div><div>Qty</div><div>Avg Px</div><div>Notional</div>
    </div>
  );
}
function Row({ p }:{ p:Position }) {
  // Use notional from position if available (calculated on backend), otherwise calculate
  const notional = p.notional ?? Math.abs(p.quantity * p.avgPrice);
  return (
    <div style={{
      display:'grid', gridTemplateColumns:'100px 1fr 1fr 1fr', gap:8,
      padding:'10px 0', borderBottom:'1px solid #334155'
    }}>
      <div style={{ fontWeight:600 }}>{p.symbol}</div>
      <div>{p.quantity.toLocaleString()}</div>
      <div>{p.avgPrice.toFixed(2)}</div>
      <div>{notional.toLocaleString()}</div>
    </div>
  );
}
